import { Prize } from "../Competition";

export const formatPrize = (prize?: Prize): string | undefined => {
  return prize ? `${prize.amount} ${prize.currency}` : undefined;
};